import { useState, useEffect, memo} from 'react'
import { useForm } from 'react-hook-form'
import { useAuth } from '../contexts/AuthContext'
import LoadingSpinner from '../components/LoadingSpinner'
import { Lock } from 'lucide-react'
import toast from 'react-hot-toast'

const SettingsPenulis = () => {
  const [saving, setSaving] = useState(false)
  const { changePassword } = useAuth()
  const passwordForm = useForm()

  const handlePasswordSubmit = async (data) => {
    setSaving(true)
    try {
      const result = await changePassword(data.currentPassword, data.newPassword)
      if (result.success) {
        passwordForm.reset()
        toast.success('Password changed successfully')
      }
    } catch (error) {
      console.error('Error changing password:', error)
      toast.error('Failed to change password')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="header-page">Settings</h1>
        <p className="description-page">Manage your account settings</p>
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Change Password</h3>
          <p className="card-description">Update your account password</p>
        </div>
        <form onSubmit={passwordForm.handleSubmit(handlePasswordSubmit)}>
          <div className="card-content space-y-4">
            <div>
              <label className="block lg:text-sm text-xs font-medium text-gray-700 mb-2">
                Current Password
              </label>
              <input
                {...passwordForm.register('currentPassword', { 
                  required: 'Current password is required' 
                })}
                type="password"
                className="input"
                placeholder="Enter current password"
              />
              {passwordForm.formState.errors.currentPassword && (
                <p className="text-red-500 text-sm mt-1">
                  {passwordForm.formState.errors.currentPassword.message}
                </p>
              )}
            </div>

            <div>
              <label className="block lg:text-sm text-xs font-medium text-gray-700 mb-2">
                New Password
              </label>
              <input
                {...passwordForm.register('newPassword', { 
                  required: 'New password is required',
                  minLength: { value: 6, message: 'Password must be at least 6 characters' }
                })}
                type="password"
                className="input"
                placeholder="Enter new password"
              />
              {passwordForm.formState.errors.newPassword && (
                <p className="text-red-500 text-sm mt-1">
                  {passwordForm.formState.errors.newPassword.message}
                </p>
              )}
            </div>

            <div>
              <label className="block lg:text-sm text-xs font-medium text-gray-700 mb-2">
                Confirm New Password
              </label>
              <input
                {...passwordForm.register('confirmPassword', { 
                  required: 'Please confirm your new password',
                  validate: value => 
                    value === passwordForm.watch('newPassword') || 'Passwords do not match'
                })}
                type="password"
                className="input"
                placeholder="Confirm new password"
              />
              {passwordForm.formState.errors.confirmPassword && (
                <p className="text-red-500 text-sm mt-1">
                  {passwordForm.formState.errors.confirmPassword.message}
                </p>
              )}
            </div>
          </div>
          <div className="card-footer">
            <button
              type="submit"
              disabled={saving}
              className="btn btn-primary"
            >
              {saving ? <LoadingSpinner size="sm" /> : <Lock className="w-4 h-4 mr-2" />}
              {saving ? 'Changing...' : 'Change Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default memo(SettingsPenulis)